<cov-button
  [buttonType]="ButtonType.PRIMARY"
  (click)="goToCart()"
  [disabled]="(numberOfItems$ | async) === 0"
>
  <cov-icon [iconName]="IconName.CART"></cov-icon>
  @if (numberOfItems$ | async; as numberOfItems) {
    <span>{{ numberOfItems }}</span>
  } @else {
    <span>0</span>
  }
</cov-button>
